(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["intag-delivery-ticker"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('intag-delivery-ticker')) {
    customElements.define('intag-delivery-ticker', class extends HTMLElement {
      connectedCallback() {
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        const toggle = this.querySelector('.intag-delivery-ticker__toggle');
        if (toggle) {
          toggle.hidden = false;
          toggle.addEventListener('click', () => {
            const paused = this.toggleAttribute('data-paused');
            toggle.setAttribute('aria-pressed', String(paused));
            toggle.setAttribute('aria-label', paused ? toggle.dataset.playLabel : toggle.dataset.pauseLabel);
          }, options);
        }
        const visibility = () => this.toggleAttribute('data-hidden', document.hidden);
        document.addEventListener('visibilitychange', visibility, options);
        visibility();
        if ('IntersectionObserver' in window) {
          this.observer = new IntersectionObserver(entries => {
            this.toggleAttribute('data-offscreen', !entries[0].isIntersecting);
          });
          this.observer.observe(this);
        }
        document.addEventListener('shopify:section:select', event => {
          if (event.target.contains(this)) this.setAttribute('data-editor', '');
        }, options);
        document.addEventListener('shopify:section:deselect', event => {
          if (event.target.contains(this)) this.removeAttribute('data-editor');
        }, options);
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.observer?.disconnect();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["popups"]) return;
  try {
    
  if (!customElements.get('intag-bundle-offer')) {
    customElements.define('intag-bundle-offer', class extends HTMLElement {
      connectedCallback() {
        this.controller = new AbortController();
        this.dialog = this.querySelector('dialog');
        if (!this.dialog || typeof this.dialog.showModal !== 'function') return;
        const options = { signal: this.controller.signal };
        this.storageKey = 'intag-bundle:' + this.dataset.campaign;
        this.querySelector('[data-bundle-close]').addEventListener('click', () => this.dialog.close(), options);
        this.dialog.addEventListener('keydown', event => {
          if (event.key !== 'Tab') return;
          const items = [...this.dialog.querySelectorAll('button:not([disabled]), a[href]')].filter(item => item.getClientRects().length);
          const first = items[0];
          const last = items[items.length - 1];
          if (event.shiftKey && document.activeElement === first) {
            event.preventDefault();
            last?.focus();
          } else if (!event.shiftKey && document.activeElement === last) {
            event.preventDefault();
            first?.focus();
          }
        }, options);
        this.dialog.addEventListener('click', event => {
          if (event.target !== this.dialog) return;
          const bounds = this.dialog.getBoundingClientRect();
          if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) this.dialog.close();
        }, options);
        document.addEventListener('shopify:block:select', event => {
          if (event.detail.blockId === this.dataset.blockId) this.openOffer(true);
        }, options);
        document.addEventListener('shopify:block:deselect', event => {
          if (event.detail.blockId === this.dataset.blockId && this.dialog.open) this.dialog.close();
        }, options);
        if (window.Shopify?.designMode) return;
        let seen = false;
        try { seen = sessionStorage.getItem(this.storageKey) === 'shown'; } catch {}
        if (this.dataset.once === 'true' && seen) return;
        this.timer = setTimeout(() => this.openOffer(false), Number(this.dataset.delay || 4) * 1000);
      }
      openOffer(editor) {
        if (this.dialog.open || !this.isConnected) return;
        const deadline = Date.parse(this.dataset.end || '');
        if (!editor && Number.isFinite(deadline) && Date.now() >= deadline) return;
        if (!editor && (document.hidden || document.querySelector('dialog[open], .modal[aria-hidden="false"]'))) {
          this.timer = setTimeout(() => this.openOffer(false), 1000);
          return;
        }
        this.dialog.showModal();
        if (!editor) {
          try { sessionStorage.setItem(this.storageKey, 'shown'); } catch {}
        }
      }
      disconnectedCallback() {
        clearTimeout(this.timer);
        if (this.dialog?.open) this.dialog.close();
        this.controller?.abort();
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
